module.exports = __webpack_public_path__ + "img/h1.0ab7e770.jpg";